var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Payout Dashboard" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  [
                    _c(
                      "div",
                      { staticClass: "pb-6 flex flex-col md:flex-row gap-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-1 rounded border border-gray-200 bg-gray-100 p-6"
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-xs uppercase font-bold text-gray-500"
                              },
                              [
                                _vm._v(
                                  "\n              Wise Balance\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "pt-2 text-3xl font-bold text-gray-800"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.wiseBalanceText) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "pt-3" },
                              [
                                _c(
                                  "VueCustomTooltip",
                                  {
                                    attrs: {
                                      label: "Refresh balance",
                                      position: "is-bottom"
                                    }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "p-2 w-8 rounded bg-blue-400 hover:bg-blue-500 focus:outline-none",
                                        on: { click: _vm.refreshWiseBalance }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "text-white",
                                          attrs: { icon: ["fa", "sync"] }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-1 rounded border border-gray-200 bg-gray-100 p-6"
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-xs uppercase font-bold text-gray-500"
                              },
                              [
                                _vm._v(
                                  "\n              Payout Value\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "pt-2 text-3xl font-bold",
                                class: _vm.hasInsufficientFunds
                                  ? "text-red-600"
                                  : "text-blue-700"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.accumulatedValueText) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pb-6 flex justify-between items-center" },
                      [
                        _c("div", { staticClass: "flex items-center" }, [
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c("form-item", {
                                attrs: { label: "From", "no-margin": "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function() {
                                      return [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "month",
                                            clearable: false,
                                            placeholder: "From month"
                                          },
                                          on: { change: _vm.onChangeStartDate },
                                          model: {
                                            value: _vm.startMonth,
                                            callback: function($$v) {
                                              _vm.startMonth = $$v
                                            },
                                            expression: "startMonth"
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mr-2" },
                            [
                              _c("form-item", {
                                attrs: { label: "To", "no-margin": "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function() {
                                      return [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "month",
                                            clearable: false,
                                            placeholder: "To month"
                                          },
                                          on: { change: _vm.onChangeEndDate },
                                          model: {
                                            value: _vm.endMonth,
                                            callback: function($$v) {
                                              _vm.endMonth = $$v
                                            },
                                            expression: "endMonth"
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "relative self-stretch" }, [
                            _c(
                              "div",
                              {
                                staticClass: "flex",
                                staticStyle: {
                                  position: "absolute",
                                  bottom: "0",
                                  width: "max-content"
                                }
                              },
                              [
                                _c("Button", {
                                  attrs: {
                                    variant: "primary",
                                    label: _vm.generateReportLabel,
                                    disabled: _vm.tickedCount === 0
                                  },
                                  on: { clicked: _vm.generateReport }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.pendingReview
                      ? _c("div", { staticClass: "pb-6" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-start rounded border border-yellow-300 bg-yellow-50 p-4"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "flex items-center justify-center w-6 h-6 mr-3 rounded-full bg-yellow-500 text-white text-sm font-bold flex-shrink-0"
                                },
                                [_vm._v("!")]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "p",
                                  { staticClass: "font-bold text-gray-800" },
                                  [
                                    _vm._v(
                                      "\n                Submitted for review — table locked\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "pt-1 text-sm text-gray-600" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.pendingReviewBannerText) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "pt-3" },
                                  [
                                    _c(
                                      "VueCustomTooltip",
                                      {
                                        attrs: {
                                          label: _vm.ownerReviewButtonTooltip,
                                          position: "is-bottom"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("Button", {
                                              attrs: {
                                                variant: "primary",
                                                label: "Open payout review"
                                              },
                                              on: {
                                                clicked: _vm.openOwnerReview
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.missingMonths.length > 0
                      ? _c("div", { staticClass: "pb-4" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-xs uppercase font-bold text-yellow-600"
                            },
                            [
                              _vm._v(
                                "\n            No payouts: " +
                                  _vm._s(_vm.missingMonths) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "data-tables-server",
                      {
                        ref: "tableTransaction",
                        attrs: {
                          data: _vm.data,
                          total: _vm.total,
                          "current-page": _vm.page,
                          "page-size": _vm.pageSize,
                          "pagination-props": {
                            background: true,
                            pageSizes: [_vm.displayingItem]
                          }
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.page = $event
                          },
                          "update:current-page": function($event) {
                            _vm.page = $event
                          },
                          "update:pageSize": function($event) {
                            _vm.pageSize = $event
                          },
                          "update:page-size": function($event) {
                            _vm.pageSize = $event
                          },
                          "query-change": _vm.onChangeTable
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "Artist Name",
                            prop: "artist.name",
                            "min-width": "200px"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center" },
                                    [
                                      _vm.isTicked(scope.row)
                                        ? _c("font-awesome-icon", {
                                            staticClass: "text-green-500 mr-2",
                                            attrs: { icon: ["fa", "check"] }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.artist.name))
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "Email",
                            prop: "artist.email",
                            "min-width": "200px"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "whitespace-no-wrap" },
                                    [_vm._v(_vm._s(scope.row.artist.email))]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.titles, function(title) {
                          return _c("el-table-column", {
                            key: title.prop,
                            attrs: { prop: title.prop, label: title.label }
                          })
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "Months", "min-width": "200px" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.months_text))
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "Bank/Wise", "min-width": "120px" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.paymentMethodText(scope.row))
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "Status", "min-width": "120px" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.payoutDisplayStatus(scope.row))
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { align: "right", "min-width": "100px" },
                          scopedSlots: _vm._u([
                            {
                              key: "header",
                              fn: function(headerScope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center justify-end"
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          value: _vm.isAllTicked,
                                          indeterminate: _vm.isIndeterminate,
                                          disabled:
                                            _vm.tickableRows.length === 0
                                        },
                                        on: { change: _vm.toggleAll }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-2" }, [
                                        _vm._v("Actions")
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "static inline-block text-left container-action"
                                    },
                                    [
                                      _c(
                                        "VueCustomTooltip",
                                        {
                                          attrs: {
                                            label: "Detail",
                                            position: "is-left"
                                          }
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                              on: {
                                                click: function($event) {
                                                  return _vm.viewDetail(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "text-white",
                                                attrs: { icon: ["fa", "eye"] }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "VueCustomTooltip",
                                        {
                                          attrs: {
                                            label: _vm.tickDisabledReason(
                                              scope.row
                                            ),
                                            position: "is-left"
                                          }
                                        },
                                        [
                                          _c("el-checkbox", {
                                            staticClass: "ml-2",
                                            attrs: {
                                              value: _vm.isTicked(scope.row),
                                              disabled: _vm.isPayDisabled(
                                                scope.row
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.togglePay(scope.row)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pt-6 pb-6 flex justify-end" },
                      [
                        _c("Button", {
                          attrs: {
                            variant: "primary",
                            label: "Schedule Payout",
                            disabled:
                              _vm.tickedCount === 0 || _vm.isReviewLocked
                          },
                          on: { clicked: _vm.saveMarkPay }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pt-6" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-xs uppercase font-bold text-gray-500"
                        },
                        [
                          _vm._v(
                            "\n            Transaction History\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pt-4" },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.transactionHistory }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "Period",
                                  prop: "period",
                                  "min-width": "180px"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Total",
                                  prop: "total",
                                  "min-width": "150px"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Artist",
                                  prop: "artist_total",
                                  "min-width": "120px"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Payment Time",
                                  prop: "payment_time",
                                  "min-width": "180px"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Status",
                                  "min-width": "120px"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "px-2 py-1 rounded text-xs font-bold",
                                            class: _vm.historyStatusClass(
                                              scope.row.status
                                            )
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(scope.row.status) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "detailArtist",
          attrs: {
            isShowingModal: _vm.isShowingDetailModal,
            isLoading: _vm.isLoading,
            title: "Detail Artist",
            labelSubmit: "Submit as Transferred"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingDetailModal = false
            },
            save: function($event) {
              return _vm.makePayment()
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "py-6" },
              [
                _c("form-item", {
                  attrs: { label: "Artist Name" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.artist.name))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Email" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.artist.email))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Wise ID" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.wiseIdentifierOf(_vm.artist) || "-"
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Bank" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  !!_vm.artist.bank ? _vm.artist.bank.bank : "-"
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Account Holder" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  !!_vm.artist.bank
                                    ? _vm.artist.bank.account_name
                                    : "-"
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Account Number" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  !!_vm.artist.bank
                                    ? _vm.artist.bank.account_number
                                    : "-"
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Swift Code" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  !!_vm.artist.bank
                                    ? _vm.artist.bank.swift_code
                                    : "-"
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", {
                  attrs: { label: "Amount" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("p", { staticClass: "text-left font-bold" }, [
                            _vm._v(_vm._s(_vm.artist.amount))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("form-item", { attrs: { label: "Paid Amount" } }, [
                  _c(
                    "div",
                    { staticClass: "inline-flex w-full gap-4 items-center" },
                    [
                      _vm._v("\n            $\n            "),
                      _c("Input", {
                        attrs: {
                          placeholder: "ex. 5",
                          error:
                            _vm.$v.input.amount.$dirty &&
                            (!_vm.$v.input.amount.required ||
                              !_vm.$v.input.amount.decimal)
                        },
                        model: {
                          value: _vm.input.amount,
                          callback: function($$v) {
                            _vm.$set(_vm.input, "amount", $$v)
                          },
                          expression: "input.amount"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col pt-2" },
                    [
                      _vm.$v.input.amount.$dirty &&
                      !_vm.$v.input.amount.required
                        ? _c("text-error", {
                            attrs: { text: "Please fill Amount." }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$v.input.amount.$dirty && !_vm.$v.input.amount.decimal
                        ? _c("text-error", {
                            attrs: { text: "Please fill Amount with number." }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "form-item",
                  { attrs: { label: "Transfer Date" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        size: "large",
                        type: "date",
                        clearable: false,
                        placeholder: "Pick a day"
                      },
                      model: {
                        value: _vm.input.payment_date,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "payment_date", $$v)
                        },
                        expression: "input.payment_date"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.payment_date.$dirty &&
                        !_vm.$v.input.payment_date.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill Payment Date." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "overflow-x-hidden overflow-y-auto fixed inset-0 top-0 left-0 outline-none focus:outline-none justify-center items-center flex",
          class: _vm.isShowingConfirmModal
            ? "z-50"
            : "opacity-0 pointer-events-none"
        },
        [
          _c("div", { staticClass: "relative w-auto my-6 mx-auto max-w-md" }, [
            _c(
              "div",
              {
                staticClass:
                  "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "p-5" }, [
                  _c("p", { staticClass: "text-gray-600" }, [
                    _vm._v("Schedule this payout batch?")
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "pt-3 text-sm text-gray-700" }, [
                    _c("li", { staticClass: "pb-1" }, [
                      _c("strong", [_vm._v("Artists:")]),
                      _vm._v(" " + _vm._s(_vm.tickedCount))
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "pb-1" }, [
                      _c("strong", [_vm._v("Total:")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.accumulatedValueText) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "pb-1" }, [
                      _c("strong", [_vm._v("Period:")]),
                      _vm._v(
                        " " + _vm._s(_vm.schedulePeriodText) + "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "pb-1" }, [
                      _c("strong", [_vm._v("Wise balance:")]),
                      _vm._v(
                        " " + _vm._s(_vm.wiseBalanceText) + "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("strong", [_vm._v("After (est.):")]),
                      _vm._v(" " + _vm._s(_vm.balanceAfterText))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150",
                        attrs: { type: "button" },
                        on: { click: _vm.closeConfirmModal }
                      },
                      [_vm._v("\n            Cancel\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "bg-blue-700 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150",
                        attrs: { type: "button" },
                        on: { click: _vm.confirmSchedulePayout }
                      },
                      [_vm._v("\n            Confirm schedule\n          ")]
                    )
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isShowingConfirmModal
        ? _c("div", { staticClass: "opacity-25 fixed inset-0 z-40 bg-black" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "overflow-x-hidden overflow-y-auto fixed inset-0 top-0 left-0 outline-none focus:outline-none justify-center items-center flex",
          class: _vm.isShowingSuccessModal
            ? "z-50"
            : "opacity-0 pointer-events-none",
          attrs: {
            role: "alertdialog",
            "aria-labelledby": "successTitle",
            "aria-describedby": "successNote"
          }
        },
        [
          _c("div", { staticClass: "relative w-auto my-6 mx-auto max-w-md" }, [
            _c(
              "div",
              {
                staticClass:
                  "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"
              },
              [
                _c("div", { staticClass: "p-6" }, [
                  _c("div", { staticClass: "flex justify-center pb-4" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "flex items-center justify-center w-12 h-12 rounded-full bg-green-100"
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "text-green-600 w-6 h-6",
                            attrs: {
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "3",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true"
                            }
                          },
                          [
                            _c("polyline", {
                              attrs: { points: "20 6 9 17 4 12" }
                            })
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "h2",
                    {
                      staticClass:
                        "text-2xl font-bold text-gray-800 text-center",
                      attrs: { id: "successTitle" }
                    },
                    [_vm._v("\n            Schedule Successful\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "pt-1 text-sm text-gray-500 text-center" },
                    [
                      _vm._v(
                        "\n            The payout batch has been scheduled.\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.scheduledSummary
                    ? _c("ul", { staticClass: "pt-4 text-left text-sm" }, [
                        _c(
                          "li",
                          {
                            staticClass:
                              "flex justify-between items-center py-2 border-b border-gray-200"
                          },
                          [
                            _c("span", { staticClass: "text-gray-500" }, [
                              _vm._v("Artists")
                            ]),
                            _vm._v(" "),
                            _c("strong", { staticClass: "text-gray-800" }, [
                              _vm._v(_vm._s(_vm.scheduledSummary.artistText))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass:
                              "flex justify-between items-center py-2 border-b border-gray-200"
                          },
                          [
                            _c("span", { staticClass: "text-gray-500" }, [
                              _vm._v("Total")
                            ]),
                            _vm._v(" "),
                            _c("strong", { staticClass: "text-gray-800" }, [
                              _vm._v(_vm._s(_vm.scheduledSummary.total))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass:
                              "flex justify-between items-center py-2 border-b border-gray-200"
                          },
                          [
                            _c("span", { staticClass: "text-gray-500" }, [
                              _vm._v("Period")
                            ]),
                            _vm._v(" "),
                            _c("strong", { staticClass: "text-gray-800" }, [
                              _vm._v(_vm._s(_vm.scheduledSummary.period))
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(1)
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center p-6 border-t border-solid border-blueGray-200 rounded-b"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "bg-blue-700 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150",
                        attrs: { type: "button" },
                        on: { click: _vm.closeSuccessModal }
                      },
                      [_vm._v("\n            Got it\n          ")]
                    )
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isShowingSuccessModal
        ? _c("div", { staticClass: "opacity-25 fixed inset-0 z-40 bg-black" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "overflow-x-hidden overflow-y-auto fixed inset-0 top-0 left-0 outline-none focus:outline-none justify-center items-center flex",
          class: _vm.isShowingOwnerModal
            ? "z-50"
            : "opacity-0 pointer-events-none",
          attrs: { role: "dialog", "aria-labelledby": "ownerTitle" }
        },
        [
          _c(
            "div",
            { staticClass: "relative w-full my-6 mx-auto max-w-3xl px-6" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-between p-5 border-b border-solid border-blueGray-200 rounded-t bg-blue-700"
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "text-xl font-semibold text-white",
                          attrs: { id: "ownerTitle" }
                        },
                        [
                          _vm._v(
                            "\n            Payout approval — account owner review\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "text-white text-2xl leading-none font-bold outline-none focus:outline-none",
                          attrs: { type: "button", "aria-label": "Close" },
                          on: { click: _vm.closeOwnerReview }
                        },
                        [_vm._v("\n            ×\n          ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col md:flex-row gap-6 p-6" },
                    [
                      _c("div", { staticClass: "flex-1" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-xs uppercase font-bold text-gray-500 pb-2"
                          },
                          [
                            _vm._v(
                              "\n              Artists to be paid\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "overflow-y-auto max-h-64 rounded border border-gray-200"
                          },
                          [
                            _c("table", { staticClass: "w-full text-sm" }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.pendingReviewArtists, function(
                                  artist
                                ) {
                                  return _c(
                                    "tr",
                                    {
                                      key: artist.email,
                                      staticClass: "border-t border-gray-200"
                                    },
                                    [
                                      _c("td", { staticClass: "px-3 py-2" }, [
                                        _c("strong", [
                                          _vm._v(_vm._s(artist.name))
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "block text-xs text-gray-500"
                                          },
                                          [_vm._v(_vm._s(artist.email))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "px-3 py-2 text-right whitespace-no-wrap"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.artistAmountText(artist)
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "md:w-64" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-xs uppercase font-bold text-gray-500 pb-2"
                          },
                          [_vm._v("\n              Summary\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "rounded border border-gray-200 p-4" },
                          [
                            _c("p", { staticClass: "text-xs text-gray-500" }, [
                              _vm._v("Total amount")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "pb-3 text-2xl font-bold text-gray-800"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.pendingReviewTotalText) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-xs text-gray-500" }, [
                              _vm._v("Artists to be paid")
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "text-base font-bold text-gray-800"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.pendingReviewCountText) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex gap-2 pt-4" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "bg-green-600 text-white active:bg-green-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed",
                              attrs: {
                                type: "button",
                                disabled: !_vm.canReviewPending
                              },
                              on: {
                                click: function($event) {
                                  return _vm.reviewPendingPayout("approved")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Approve\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "bg-red-600 text-white active:bg-red-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed",
                              attrs: {
                                type: "button",
                                disabled: !_vm.canReviewPending
                              },
                              on: {
                                click: function($event) {
                                  return _vm.reviewPendingPayout("rejected")
                                }
                              }
                            },
                            [_vm._v("\n                Reject\n              ")]
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.canReviewPending
                          ? _c(
                              "p",
                              { staticClass: "pt-3 text-xs text-gray-500" },
                              [
                                _vm._v(
                                  "\n              View only — only the account owner can approve or reject this\n              batch.\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.isShowingOwnerModal
        ? _c("div", { staticClass: "opacity-25 fixed inset-0 z-40 bg-black" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t"
      },
      [
        _c("h3", { staticClass: "text-xl font-semibold" }, [
          _vm._v("Confirm schedule payout")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "mt-4 flex items-start p-3 rounded border border-yellow-200 bg-yellow-50",
        attrs: { id: "successNote" }
      },
      [
        _c(
          "span",
          {
            staticClass:
              "flex items-center justify-center w-5 h-5 rounded-full bg-yellow-500 text-white text-xs font-bold"
          },
          [_vm._v("!")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { staticClass: "bg-gray-100 text-left" }, [
        _c("th", { staticClass: "px-3 py-2" }, [_vm._v("Artist")]),
        _vm._v(" "),
        _c("th", { staticClass: "px-3 py-2 text-right" }, [_vm._v("Amount")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed96ed78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed96ed78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PayoutDashboard.vue
// module id = null
// module chunks = 